import USER_ROLES from './UserRoles';

export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const APP_LOCALES = ['en', 'iw'];
export const DEFAULT_LOCALE = 'en';
export const TCP_PORT = process.env.TCP_SIMULATOR_PORT || 8100;
export const TCP_HOST = process.env.TCP_SIMULATOR_HOST || '35.154.72.117';
export const API_SERVER_PORT = process.env.SERVER_PORT || 8001;
export const HTTP_SERVER_PORT = process.env.HTTP_PORT || 8002;
export const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY || 'AIzaSyBW3pYQey8PRcqlRZAqKUWVApJs_CvuiJI';

// REMOVE IT
export const DEV_DATA = {
  context: {
    token: 'Bearer 1234567890',
    user: {
      firstName: 'User',
      lastName: 'Dummy',
      role: 'Admin',
    },
  },
  roles: ['Admin', 'User'],
  email: 'dev@wa.com',
};

export const SNACKBAR_VARIANTS = {
  ERROR: 'error',
  SUCCESS: 'success',
  DEFAULT: 'default',
  WARNING: 'warning',
  INFO: 'info',
};

export const ROLE_LANDING_PAGE_MAP = {
  0: '/admin/dashboard',
  1: '/admin/dashboard',
  2: '/admin/dashboard',
  3: '/user/overview',
  4: '/user/overview',
  5: '/user/detail/currentUser',
  7: '/admin/task/dashboard',
  8: '/admin/task/dashboard',
  default: '/',
};

export const GATEWAY_ROLE_LANDING_PAGE_MAP = {
  0: '/admin/dashboard',
  1: '/admin/gateway',
  2: '/admin/gateway',
  3: '/user/overview',
  4: '/user/overview',
  5: '/user/detail/currentUser',
  6: '/admin/gateway/roomViewInteractions',
  default: '/',
};

export const CURRENT_USER_ROUTE_UUID = 'currentUser';
export const DROPDOWN_NONE = {
  value: '@@@%%@@@',
  label: 'None',
};

export const DROPDOWN_ALL = {
  value: '@@@%%@@@',
  label: 'All',
};

export const ADMIN_ROLE_GROUP = [USER_ROLES.ADMIN, USER_ROLES.MANAGER];
export const SUPERVISOR_ROLE_GROUP = [...ADMIN_ROLE_GROUP, USER_ROLES.SUPERVISOR];
export const SUPERVISOR_MONITOR_ROLE_GROUP = [...SUPERVISOR_ROLE_GROUP, USER_ROLES.BRANCH_MONITOR, USER_ROLES.COMPANY_MONITOR]
export const MONITOR_USER_GROUP = [...SUPERVISOR_ROLE_GROUP, USER_ROLES.MONITOR];
export const ALL_MONITOR_USER_GROUP = [...MONITOR_USER_GROUP, USER_ROLES.BRANCH_MONITOR, USER_ROLES.COMPANY_MONITOR]
export const WATCHUSER_ROLE_GROUP = [USER_ROLES.OWNER, USER_ROLES.RELATIVE];
export const OWNER_ROLE_GROUP = [...ADMIN_ROLE_GROUP, USER_ROLES.OWNER];
export const ALL_LOGGED_ROLES = [...ALL_MONITOR_USER_GROUP, ...WATCHUSER_ROLE_GROUP];
export const NON_MANAGER_ROLES = [...WATCHUSER_ROLE_GROUP, USER_ROLES.USER];
export const NON_ADMIN_ROLES = [...NON_MANAGER_ROLES, USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR];
